// Configuración optimizada para React Query
export const queryConfig = {
  // Configuración por defecto para todas las queries
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutos
      gcTime: 5 * 60 * 1000, // 5 minutos (anteriormente cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
  
  // Configuraciones específicas por tipo de query
  submission: {
    staleTime: 5 * 60 * 1000, // 5 minutos para datos de submission
    gcTime: 10 * 60 * 1000, // 10 minutos
  },
  
  answers: {
    staleTime: 5 * 60 * 1000, // 5 minutos para respuestas
    gcTime: 10 * 60 * 1000, // 10 minutos
  },
  
  rag: {
    staleTime: 2 * 60 * 1000, // 2 minutos para datos RAG
    gcTime: 5 * 60 * 1000, // 5 minutos
  },
  
  comparativa: {
    staleTime: 10 * 60 * 1000, // 10 minutos para datos de comparativa
    gcTime: 15 * 60 * 1000, // 15 minutos
  },
};

// Función helper para obtener configuración específica
export const getQueryConfig = (type: keyof typeof queryConfig) => {
  return queryConfig[type] || queryConfig.defaultOptions.queries;
}; 